// Centralized translations: SV (default) + EN
export const translations = {
  sv: {
    nav: {
      services: "Tjänster",
      about: "Om uppdraget",
      pricing: "Priser",
      faq: "Vanliga frågor",
      contact: "Kontakt",
      book: "Boka tid",
    },
    hero: {
      eyebrow: "Notarius Publicus · Förordnad av Länsstyrelsen",
      headline_a: "Officiell",
      headline_b: "bestyrkande",
      headline_c: "när det gäller.",
      lede:
        "Daniel Madsen är av Länsstyrelsen förordnad notarius publicus i Vårgårda, Herrljunga och Vara kommun — med rätt att verka i hela riket. Apostille, bevittning, vidimering och övriga officiella förrättningar.",
      cta_primary: "Boka förrättning",
      cta_secondary: "Se tjänster",
      stat_a: "Förordnande i 3 kommuner",
      stat_b: "Verksam i hela Sverige",
      stat_c: "Återkoppling inom 24h",
    },
    about: {
      eyebrow: "Förordnandet",
      title: "En officiell roll. En personlig service.",
      body_1:
        "Notarius publicus är en av Länsstyrelsen förordnad person med uppgift att hjälpa allmänheten med vissa juridiska handlingar — såsom att intyga riktigheten av kopior, bevittna namnteckningar och utfärda apostille enligt Haag-konventionen.",
      body_2:
        "Daniel Madsen är förordnad i Vårgårda, Herrljunga och Vara kommun. Förordnandet ger rätt att utföra förrättningar i hela Sverige — oavsett var dina handlingar ska användas.",
      municipalities: ["Vårgårda kommun", "Herrljunga kommun", "Vara kommun"],
      caption: "Förrättning sker på kontor eller på distans efter överenskommelse.",
    },
    services: {
      eyebrow: "Tjänster",
      title: "Förrättningar som notarius publicus.",
      lede:
        "Vanligt förekommande uppdrag — för privatpersoner, företag och internationella klienter.",
      list: [
        {
          k: "01",
          t: "Apostille",
          d: "Apostille enligt Haag-konventionen för handlingar som ska användas i andra länder anslutna till konventionen.",
        },
        {
          k: "02",
          t: "Bevittning av underskrift",
          d: "Officiell bevittning och bekräftelse av att en namnteckning gjorts av angiven person.",
        },
        {
          k: "03",
          t: "Vidimering av kopior",
          d: "Bestyrkande av att en kopia överensstämmer med originalhandlingen — vanligt vid utländska myndigheter.",
        },
        {
          k: "04",
          t: "Bestyrkande av översättningar",
          d: "Bekräftelse av översättarens behörighet och underskrift på en översatt handling.",
        },
        {
          k: "05",
          t: "Levnadsintyg",
          d: "Intyg om att en person är vid liv — krävs t.ex. för utländska pensionsmyndigheter.",
        },
        {
          k: "06",
          t: "Behörighets- och ställningsintyg",
          d: "Bekräftelse av en persons behörighet att företräda bolag eller annan organisation.",
        },
      ],
    },
    pricing: {
      eyebrow: "Priser",
      title: "Transparent prissättning per förrättning.",
      lede:
        "Alla priser är inklusive moms. Tjänster märkta från X kr eller enligt offert prissätts individuellt via kontakt.",
      sections: [
        {
          heading: "Standardtjänster",
          rows: [
            { t: "Bevittning av namnteckning", p: "500 kr" },
            { t: "Vidimering av kopia", p: "500 kr" },
            { t: "Apostille", p: "650 kr / dokument" },
            { t: "Intyg om namnunderskrift", p: "500 kr" },
            { t: "Fullmakter/intyg — enklare handlingar", p: "från 750 kr" },
            { t: "Firmateckningsintyg", p: "850 kr" },
            { t: "Intyg av pass/id-handling", p: "500 kr" },
            { t: "Certifiering av översättning", p: "från 950 kr" },
            { t: "Affidavit / deklaration under ed", p: "från 1 500 kr" },
            { t: "Närvaro-/levnadsintyg", p: "850 kr" },
            { t: "Bestyrkande av examenshandlingar", p: "500 kr" },
          ],
        },
        {
          heading: "Företag & större ärenden",
          rows: [
            { t: "Bolagshandlingar (styrelseprotokoll m.m.)", p: "från 1 250 kr" },
            { t: "Due diligence / intygspaket", p: "enligt offert" },
            { t: "Certifiering av större dokumentpaket", p: "enligt offert" },
            { t: "Utländska handlingar / komplexa ärenden", p: "från 1 500 kr" },
          ],
        },
        {
          heading: "Utryckning & särskilda tjänster",
          rows: [
            { t: "Förrättning utanför kontor dagtid", p: "3 000 kr / timme" },
            { t: "Förrättning kväll/helg", p: "4 000 kr / timme" },
            { t: "Resekostnad", p: "65 kr / mil" },
            { t: "Akutärende samma dag", p: "tillägg 750–1 500 kr" },
          ],
        },
      ],
      footnote:
        "Minsta debitering 500 kr. Påbörjad kvart debiteras vid tidsbaserade uppdrag. Betalning via Swish, kort eller Klarna.",
    },
    faq: {
      eyebrow: "Vanliga frågor",
      title: "Bra att veta.",
      items: [
        {
          q: "Vad är skillnaden mellan apostille och legalisering?",
          a: "Apostille gäller mellan länder anslutna till Haag-konventionen och ersätter äldre legalisering. För länder utanför konventionen krävs vanligtvis legalisering via UD och berörd ambassad.",
        },
        {
          q: "Vilka handlingar behöver apostille?",
          a: "Vanligtvis examensbevis, fullmakter, registreringsbevis, äktenskapsintyg, födelseattester eller andra svenska officiella handlingar som ska användas utomlands.",
        },
        {
          q: "Måste jag komma in personligen?",
          a: "Ja, vid bevittning av underskrift krävs personlig inställelse med giltig legitimation. Apostille och vidimering kan i vissa fall hanteras på distans.",
        },
        {
          q: "Vilken legitimation gäller?",
          a: "Svenskt körkort, pass, nationellt id-kort eller annan godkänd id-handling. Den måste vara giltig (ej utgången).",
        },
        {
          q: "Hur lång tid tar det?",
          a: "De flesta förrättningar utförs på plats inom 10–20 minuter. För större mängder handlingar bokas separat tid.",
        },
        {
          q: "Kan jag få förrättning på engelska?",
          a: "Ja. Both Swedish and English are spoken — feel free to book in either language.",
        },
      ],
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Boka tid.",
      lede:
        "Fyll i formuläret så återkommer vi inom 24 timmar. Vid brådskande ärenden — ring direkt.",
      address_label: "Besöksadress",
      phone_label: "Telefon",
      email_label: "E-post",
      hours_label: "Öppettider",
      hours: "Mån — Fre · 09.00 — 17.00",
      form: {
        name: "Namn",
        email: "E-post",
        phone: "Telefon",
        service: "Typ av förrättning",
        service_placeholder: "Välj tjänst",
        message: "Meddelande",
        message_placeholder: "Beskriv kort vad ärendet gäller…",
        submit: "Skicka förfrågan",
        submitting: "Skickar…",
        consent:
          "Genom att skicka godkänner du att vi behandlar dina personuppgifter för att återkomma i ditt ärende.",
        success_title: "Tack — din förfrågan är mottagen.",
        success_body: "Vi återkommer inom 24 timmar.",
        error_title: "Något gick fel.",
        error_body: "Försök igen eller ring oss direkt.",
        validation_required: "Fältet är obligatoriskt",
        validation_email: "Ange en giltig e-postadress",
      },
    },
    footer: {
      tagline: "Notarius Publicus — Vårgårda · Herrljunga · Vara",
      rights: "Alla rättigheter förbehållna.",
      auth: "Av Länsstyrelsen förordnad notarius publicus.",
    },
    lang_label: { sv: "Svenska", en: "English" },
  },

  en: {
    nav: {
      services: "Services",
      about: "About",
      pricing: "Pricing",
      faq: "FAQ",
      contact: "Contact",
      book: "Book a time",
    },
    hero: {
      eyebrow: "Notary Public · Appointed by the County Administrative Board",
      headline_a: "Official",
      headline_b: "certification",
      headline_c: "when it matters.",
      lede:
        "Daniel Madsen is appointed Notarius Publicus for the municipalities of Vårgårda, Herrljunga and Vara — with authority to act throughout Sweden. Apostille, witnessing, certified copies and other official acts.",
      cta_primary: "Book an appointment",
      cta_secondary: "View services",
      stat_a: "Appointed in 3 municipalities",
      stat_b: "Authority across Sweden",
      stat_c: "Reply within 24h",
    },
    about: {
      eyebrow: "The appointment",
      title: "An official role. A personal service.",
      body_1:
        "A notarius publicus is a person appointed by the Swedish County Administrative Board (Länsstyrelsen) to assist the public with certain legal acts — including certifying copies, witnessing signatures and issuing apostilles under the Hague Convention.",
      body_2:
        "Daniel Madsen is appointed for the municipalities of Vårgårda, Herrljunga and Vara. The appointment grants authority to perform official acts throughout Sweden — wherever your documents are intended to be used.",
      municipalities: ["Vårgårda Municipality", "Herrljunga Municipality", "Vara Municipality"],
      caption: "Appointments at the office or remotely by arrangement.",
    },
    services: {
      eyebrow: "Services",
      title: "Acts performed by the notary public.",
      lede: "Common assignments — for individuals, companies and international clients.",
      list: [
        {
          k: "01",
          t: "Apostille",
          d: "Apostille under the Hague Convention for documents used in other contracting states.",
        },
        {
          k: "02",
          t: "Witnessing of signatures",
          d: "Official confirmation that a signature was made by the named person.",
        },
        {
          k: "03",
          t: "Certified copies",
          d: "Certification that a copy is a true reproduction of the original — often required by foreign authorities.",
        },
        {
          k: "04",
          t: "Certification of translations",
          d: "Confirmation of the translator's authority and signature on a translated document.",
        },
        {
          k: "05",
          t: "Certificate of life",
          d: "Confirming that a person is alive — often required by foreign pension authorities.",
        },
        {
          k: "06",
          t: "Certificate of authority",
          d: "Confirming a person's authority to represent a company or other organization.",
        },
      ],
    },
    pricing: {
      eyebrow: "Pricing",
      title: "Transparent fees per service.",
      lede:
        "All prices include VAT. Services marked from SEK X or on quotation are priced individually — please get in touch.",
      sections: [
        {
          heading: "Standard services",
          rows: [
            { t: "Witnessing of signature", p: "SEK 500" },
            { t: "Certified copy", p: "SEK 500" },
            { t: "Apostille", p: "SEK 650 / document" },
            { t: "Certificate of signature", p: "SEK 500" },
            { t: "Powers of attorney / simpler documents", p: "from SEK 750" },
            { t: "Certificate of authorized signatory", p: "SEK 850" },
            { t: "Certification of passport / ID", p: "SEK 500" },
            { t: "Certification of translation", p: "from SEK 950" },
            { t: "Affidavit / sworn declaration", p: "from SEK 1 500" },
            { t: "Certificate of life / presence", p: "SEK 850" },
            { t: "Certification of academic documents", p: "SEK 500" },
          ],
        },
        {
          heading: "Companies & larger matters",
          rows: [
            { t: "Corporate documents (board minutes etc.)", p: "from SEK 1 250" },
            { t: "Due diligence / certification packages", p: "on quotation" },
            { t: "Certification of larger document sets", p: "on quotation" },
            { t: "Foreign / complex matters", p: "from SEK 1 500" },
          ],
        },
        {
          heading: "On-site & special services",
          rows: [
            { t: "Off-site assignment, daytime", p: "SEK 3 000 / hour" },
            { t: "Evening / weekend assignment", p: "SEK 4 000 / hour" },
            { t: "Travel cost", p: "SEK 65 / 10 km" },
            { t: "Same-day urgent matter", p: "surcharge SEK 750–1 500" },
          ],
        },
      ],
      footnote:
        "Minimum charge SEK 500. Time-based work is billed in started 15-minute increments. Payment via Swish, card or Klarna.",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Good to know.",
      items: [
        {
          q: "What is the difference between apostille and legalization?",
          a: "Apostille applies between countries party to the Hague Convention and replaces older legalization. For non-convention countries, legalization through the Ministry for Foreign Affairs and the relevant embassy is usually required.",
        },
        {
          q: "Which documents need an apostille?",
          a: "Typically diplomas, powers of attorney, certificates of registration, marriage certificates, birth certificates or other Swedish official documents to be used abroad.",
        },
        {
          q: "Do I need to attend in person?",
          a: "Yes, for witnessing of signatures personal attendance with valid ID is required. Apostille and certified copies may in some cases be handled remotely.",
        },
        {
          q: "What ID is accepted?",
          a: "Swedish driver's licence, passport, national ID card or other approved valid identification (not expired).",
        },
        {
          q: "How long does it take?",
          a: "Most acts are performed on the spot in 10–20 minutes. Larger volumes are scheduled separately.",
        },
        {
          q: "Can the appointment be in English?",
          a: "Yes — appointments can be conducted in Swedish or English.",
        },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Book your appointment.",
      lede:
        "Fill out the form and we'll respond within 24 hours. For urgent matters, please call us directly.",
      address_label: "Address",
      phone_label: "Phone",
      email_label: "Email",
      hours_label: "Hours",
      hours: "Mon — Fri · 08.30 — 17.30",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        service: "Type of service",
        service_placeholder: "Select a service",
        message: "Message",
        message_placeholder: "Briefly describe your matter…",
        submit: "Send request",
        submitting: "Sending…",
        consent:
          "By submitting you consent to processing of your personal data so we can respond to your request.",
        success_title: "Thank you — your request has been received.",
        success_body: "We'll get back to you within 24 hours.",
        error_title: "Something went wrong.",
        error_body: "Please try again or call us directly.",
        validation_required: "This field is required",
        validation_email: "Enter a valid email address",
      },
    },
    footer: {
      tagline: "Notary Public — Vårgårda · Herrljunga · Vara",
      rights: "All rights reserved.",
      auth: "Notarius Publicus appointed by the County Administrative Board.",
    },
    lang_label: { sv: "Svenska", en: "English" },
  },
};

export const CONTACT = {
  address: "Åsbogärde 2, 524 92 Herrljunga",
  phone_display: "010-808 56 13",
  phone_link: "+46108085613",
  email: "kontakt@bmjuridik.se",
};
